import type { CalculationMode, ModeDefinition } from "../calculators/weldParameter/types";
import { copy } from "../data/i18n";
import { unitFor } from "../data/units";
import type { Language, UnitSystem } from "../types/preferences";

type ModeSelectorProps = {
  modes: ModeDefinition[];
  activeMode: CalculationMode;
  language: Language;
  unitSystem: UnitSystem;
  onChange: (mode: CalculationMode) => void;
};

export function ModeSelector({
  modes,
  activeMode,
  language,
  unitSystem,
  onChange
}: ModeSelectorProps) {
  const t = copy[language];

  return (
    <div className="mode-selector" role="radiogroup" aria-label="Berechnung auswählen">
      {modes.map((definition) => (
        <button
          key={definition.mode}
          type="button"
          className={definition.mode === activeMode ? "mode-button is-active" : "mode-button"}
          onClick={() => onChange(definition.mode)}
          role="radio"
          aria-checked={definition.mode === activeMode}
        >
          <span>{t.modes[definition.mode].shortLabel}</span>
          <small>{unitFor(definition.mode, unitSystem)}</small>
        </button>
      ))}
    </div>
  );
}
